import { Card, Spinner } from 'react-bootstrap';
import AddDomainDrawer from '@/app/Domain/components/AddDomainDrawer';
import { OnboardingPageSkeleton } from '../components/common/Skeleton';
import { SetupCompetitorStep } from '../components/project-setup/SetupCompetitorStep';
import { SetupInfoStep } from '../components/project-setup/SetupInfoStep';
import { SetupModalFooter } from '../components/project-setup/SetupModalFooter';
import { SetupPromptStep } from '../components/project-setup/SetupPromptStep';
import { PromptRunProgress } from '../components/prompts/PromptRunProgress';
import { SetupDoneCard, SetupStepper } from '../components/project-setup/SetupStepper';
import { useProjectSetup } from '../hooks/useProjectSetupOnboarding';

export default function OnboardingPage() {
  const setup = useProjectSetup();
  const tracking = setup.promptPhase === 'tracking';
  const promptDone = setup.promptPhase === 'done' || setup.hasPrompts;
  const currentStep =
    setup.promptPhase === 'done' ? 4 : setup.step === 'info' ? 1 : setup.step === 'competitor' ? 2 : 3;

  const leaving =
    setup.promptPhase === 'form' &&
    setup.ready &&
    !setup.needsProject &&
    setup.hasCompetitors &&
    setup.hasPrompts;

  if (!setup.ready) {
    return <OnboardingPageSkeleton />;
  }

  if (leaving) {
    return (
      <div className="d-flex justify-content-center py-5">
        <Spinner animation="border" />
      </div>
    );
  }

  return (
    <>
      <div className="w-50 mx-auto">
      <div className="mb-3">
        <h2 className="fs-2 fw-semibold text-1000 mb-1">راه‌اندازی پروژه</h2>
        <p className="fs--1 text-500 mb-0">سه قدم کوتاه برای شروع ردیابی دیده‌شدن برند در AI</p>
      </div>

      <SetupStepper currentStep={currentStep} />

      <Card className="mb-3 border">
        <Card.Body>
          {setup.step === 'info' && (
            <SetupInfoStep
              domainOptions={setup.domainOptions}
              selectedDomainOption={setup.selectedDomainOption}
              onDomainChange={setup.handleDomainChange}
              onAddDomain={() => setup.setAddDomainDrawerOpen(true)}
              aliases={setup.aliases}
              onAddAlias={setup.addAlias}
              onRemoveAlias={setup.removeAlias}
              onSubmit={setup.handleEnsureProject}
            />
          )}

          {setup.step === 'competitor' && (
            <SetupCompetitorStep
              competitors={setup.competitors}
              form={setup.competitorForm}
              saving={setup.savingCompetitor}
              deletingCompetitorId={setup.deletingCompetitorId}
              onSubmit={setup.handleSaveCompetitor}
              onDelete={(id) => void setup.handleDeleteCompetitor(id)}
            />
          )}

          {setup.step === 'prompt' &&
            (tracking ? (
              <PromptRunProgress onComplete={setup.completePromptTracking} />
            ) : promptDone ? (
              <SetupDoneCard
                title="راه‌اندازی کامل شد"
                description="پروژه شما آماده است. از داشبورد می‌توانید ببینید برندتان در پاسخ‌های AI چقدر دیده می‌شود و با رقبا مقایسه کنید."
              />
            ) : (
              <SetupPromptStep
                form={setup.promptForm}
                creatingPrompt={setup.creatingPrompt}
                onSubmit={setup.handleSavePrompt}
              />
            ))}
        </Card.Body>
        <Card.Footer className="bg-body-tertiary d-flex justify-content-end">
          <SetupModalFooter
            step={setup.step}
            ensuringProject={setup.ensuringProject}
            hasValidDomain={setup.hasValidDomain}
            hasCompetitors={setup.hasCompetitors}
            competitors={setup.competitors}
            creatingPrompt={setup.creatingPrompt}
            promptForm={setup.promptForm}
            promptPhase={setup.promptPhase}
            hasPrompts={setup.hasPrompts}
            onContinueToPrompt={() => setup.setStep('prompt')}
            onFinish={setup.finishSetup}
          />
        </Card.Footer>
      </Card>
      </div>

      <AddDomainDrawer
        show={setup.addDomainDrawerOpen}
        setShow={setup.setAddDomainDrawerOpen}
      />
    </>
  );
}
